import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import type { ExternalDataOpportunityInformation } from '~/utils/interfaces';
import { convertToFixedNumberOfDecimals } from '~/utils/math-helper';

@Component({})
export default class LinkedOpportunityCollapsibleComponent extends Vue {
    @Prop()
    private data!: ExternalDataOpportunityInformation;

    private convertToFixedNumberOfDecimals = (value: number) => convertToFixedNumberOfDecimals(value)
}
